<template>
    <div class="header">
        <a href="https://www.afisha.ru/" target="_blank" class="afisha-logo" @click="gaSend('afisha logo')">
            <img src="/static/images/afisha.png" alt="">
        </a>
        <a href="https://www.megafon.ru/go/roaming_goodbye?utm_source=afisha&utm_campaign=fed_flight_www-b2c_afisha-special-project-roaming-goodbye-2-jul-2018_rf&utm_medium=ag-media_media_logo_logo_cpc__&utm_content=&utm_term" target="_blank" class="megafon-logo" :class="{ 'megafon-logo-color' : GET_LOAD }" @click="gaSend('megafon logo')">
            <megafon></megafon>
        </a>
    </div>
</template>

<script>
    import {TweenMax} from 'gsap'
    import {mapGetters} from 'vuex';
    import Helpers from '@/tools/Helpers'

    import megafon from '@/assets/svg/megafon.svg'
    export default {
        name: 'headerApp',
        components: {
            megafon
        },
        computed: {
            ...mapGetters(['GET_LOAD']),
            routerName() {
                return this.$route.name;
            }
        },
        methods: {
            gaSend(index) {
                if (this.routerName == 'Main' ) {
                    Helpers.ga().send( 'Main page', 'Click', index);
                }  else if (this.routerName == 'Country') {
                    Helpers.ga().send( 'County inner page', 'Click', index);
                } else if (this.routerName == 'Main' && !this.GET_LOAD) {
                    Helpers.ga().send( 'County page', 'Click', index);
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// headerApp.vue?2419cdf1